"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSearchInput = exports.StyledMenuContentWrapper = exports.StyledMenu = exports.StyledArrowIcon = exports.StyledListItem = exports.StyledList = exports.StyledSettingsSelector = void 0;
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledSettingsSelector = styled_components_1.default.div `
  && {
    display: flex;
    height: 2.25rem;
    border-radius: 4px;
    border: 1px solid ${ui_components_1.baseColors.primaryGray200};
    cursor: pointer;
  }
`;
exports.StyledList = (0, styled_components_1.default)(material_1.List) `
  flex: 1;
  overflow: hidden;
  padding: 0;

  > .MuiListItem-root {
    justify-content: 'space-between';
    &:hover {
      background: none;
    }
  }
`;
exports.StyledListItem = (0, styled_components_1.default)(material_1.ListItemButton) `
  height: 100%;
  display: flex;
  gap: ${({ theme }) => theme.spacing(0.5)};
  
  &:hover {
    background-color: transparent;
  }

  & .MuiListItemText-primary,
  & path {
    transition: all .2s ease-in-out;
  }

  & .MuiListItemText-primary {
    font-size: 0.875rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  & .icon-wrapper-class {
    margin: '17px 0 0 3px';
  }

  .MuiCircularProgress-root {
    width: 1rem;
    height: 1rem;
  }
`;
exports.StyledArrowIcon = (0, styled_components_1.default)(ui_components_1.Icon) `
  ${({ $menuOpen }) => $menuOpen && 'transform: rotate(180deg)'};
`;
exports.StyledMenu = (0, styled_components_1.default)(material_1.Menu) `
  .MuiPaper-root {
    box-sizing: border-box;
    max-width: 400px;
    min-width: 300px;
    padding: ${({ theme }) => theme.spacing(1)};;
    border-radius: 4px;
    color: ${ui_components_1.baseColors.primaryBlueDark500};
    margin-top: 12px;
    text-align: center;
    max-height: 500px;
    z-index: 1400;
    overflow-y: auto;
    overflow-x: hidden;
    box-shadow: ${ui_components_1.shadows.appMenu};
  }

  & .MuiList-root {
    display: flex;
  }
`;
exports.StyledMenuContentWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  overflow: hidden;
  gap: ${({ theme }) => theme.spacing(1)};
  flex: 1;
`;
exports.StyledSearchInput = (0, styled_components_1.default)(material_1.OutlinedInput) `
  && {
    height: 48px;
    min-width: 260px;
    flex-basis: fill;
    border-radius: 4px;
    margin: 0;

    &:hover .MuiOutlinedInput-notchedOutline,
    &.Mui-focused .MuiOutlinedInput-notchedOutline,
    .MuiOutlinedInput-notchedOutline {
      border-color: ${({ theme }) => theme.palette.grey[200]};
      border-width: 1px;
    }
  }
`;
